import { render, staticRenderFns } from "./DetalhesCotacaoDialog.vue?vue&type=template&id=a21b304e&scoped=true"
import script from "./DetalhesCotacaoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesCotacaoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetalhesCotacaoDialog.vue?vue&type=style&index=0&id=a21b304e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21b304e",
  null
  
)

export default component.exports